import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	container: {
		display: 'flex',
		alignSelf: 'stretch',
		width: '100%',
		boxSizing: 'border-box',
		gap: token('space.200'),
		borderRadius: token('radius.large'),
		backgroundColor: token('elevation.surface.sunken'),
		paddingTop: token('space.150'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.200'),
	},
	item: {
		display: 'flex',
		flexDirection: 'column',
		gap: token('space.050'),
		flex: '1 1 0',
		minWidth: '0px',
	},
	itemWithDivider: {
		borderInlineStart: `${token('border.width')} solid ${token('color.border')}`,
		paddingInlineStart: token('space.200'),
	},
	label: {
		font: token('font.heading.xxsmall'),
		color: token('color.text.subtle'),
	},
});

export type CardMetadataSummaryItem = {
	label: string;
	value: React.ReactNode;
};

export type CardMetadataSummaryProps = {
	items: CardMetadataSummaryItem[];
};

export const CardMetadataSummary = ({ items }: CardMetadataSummaryProps): React.JSX.Element => {
	return (
		<Box xcss={styles.container} testId="jsm-solution-composer-plan-task-card.metadata-summary">
			{items.map((item, index) => (
				<Box key={item.label} xcss={cx(styles.item, index > 0 && styles.itemWithDivider)}>
					<Box as="span" xcss={styles.label}>
						{item.label}
					</Box>
					<Text size="medium" weight="regular" color="color.text">
						{item.value}
					</Text>
				</Box>
			))}
		</Box>
	);
};
